var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-home-game-wheel" }, [
    _c(
      "div",
      {
        staticClass: "spinner",
        class: {
          spinner_winning:
            (_vm.game && _vm.game.status === _vm.GameStatus.ENDED) ||
            _vm.animationEnded,
        },
      },
      [
        _c("HomeGameWheelInformation", {
          attrs: {
            countdownSeconds: _vm.game ? _vm.game.countdownSeconds : undefined,
            "win-color": _vm.game ? _vm.game.winColor : undefined,
            "game-status": _vm.game ? _vm.game.status : undefined,
            "users-count": _vm.game ? _vm.game.usersCount : 0,
            "total-bank-usd": _vm.game ? _vm.game.totalBankUsd : 0,
          },
        }),
        _c("div", { staticClass: "spinner__wrapper" }, [
          _c("div", { staticClass: "spinner__content" }, [
            _c(
              "svg",
              {
                ref: "wheel",
                staticClass: "spinner__svg",
                style: _vm.svgStyle,
                attrs: {
                  width: "1060",
                  height: "1060",
                  viewBox: "0 0 1060 1060",
                  fill: "none",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                },
              },
              [
                _c(
                  "g",
                  {
                    staticClass: "cells",
                    attrs: { "clip-path": "url(#clip0_10105_81845)" },
                  },
                  [
                    _c("g", { attrs: { opacity: "0.51" } }, [
                      _c("path", {
                        attrs: {
                          d: "M1051.71 477.608C1080.51 765.808 870.208 1022.91 582.008 1051.71C293.708 1080.51 36.7082 870.208 7.9082 582.008C-20.8918 293.808 189.308 36.708 477.608 7.90795C765.908 -20.892 1022.81 189.308 1051.71 477.608Z",
                          fill: "#2E3866",
                        },
                      }),
                    ]),
                    _c("path", {
                      attrs: {
                        d: "M528.808 1059.31C476.008 1059.31 423.808 1051.41 373.208 1035.71C307.808 1015.41 247.708 983.108 194.408 939.508C141.108 895.908 97.6081 843.508 64.8081 783.408C30.8081 721.208 10.0081 653.608 2.90808 582.508C-4.19192 511.308 2.80808 440.908 23.8081 373.208C44.1081 307.808 76.4081 247.708 120.008 194.408C163.508 141.208 216.108 97.6079 276.208 64.7079C338.408 30.7079 406.008 9.90786 477.108 2.80786C548.208 -4.19214 618.608 2.80786 686.308 23.8079C751.708 44.1079 811.808 76.4079 865.108 120.008C918.308 163.508 961.908 216.108 994.808 276.208C1028.81 338.408 1049.61 406.008 1056.71 477.108C1063.81 548.208 1056.81 618.608 1035.81 686.308C1015.51 751.708 983.208 811.808 939.608 865.108C896.108 918.308 843.508 961.908 783.408 994.808C721.208 1028.81 653.608 1049.61 582.508 1056.71C564.508 1058.41 546.608 1059.31 528.808 1059.31ZM530.708 10.2079C513.208 10.2079 495.708 11.1079 478.008 12.8079C193.008 41.3079 -15.6919 296.408 12.8081 581.508C26.6081 719.608 93.4081 844.008 200.708 931.908C308.008 1019.81 443.308 1060.61 581.408 1046.71C866.408 1018.21 1075.11 763.108 1046.61 478.108C1032.81 340.008 966.108 215.608 858.708 127.708C765.008 51.0079 650.208 10.2079 530.708 10.2079Z",
                        fill: "#1C223F",
                      },
                    }),
                    _vm._l(_vm.CELLS, function (cell, index) {
                      return _c("path", {
                        key: index,
                        staticClass: "cells__cell",
                        class: [
                          cell.color,
                          {
                            cells__cell_winner:
                              _vm.winCell !== null && index === _vm.winCell,
                          },
                        ],
                        attrs: { d: cell.d },
                      })
                    }),
                  ],
                  2
                ),
                _c("defs", [
                  _c("clipPath", { attrs: { id: "clip0_10105_81845" } }, [
                    _c("rect", {
                      attrs: {
                        width: "1059.1",
                        height: "1059.1",
                        fill: "white",
                        transform: "translate(0.208008 0.207764)",
                      },
                    }),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "spinner__arrow" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }